import { render, staticRenderFns } from "./YedieminForm.vue?vue&type=template&id=64d31f1d"
import script from "./YedieminForm.vue?vue&type=script&lang=ts"
export * from "./YedieminForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports